import styled from "styled-components"

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  margin: 2rem 0px;

  width: min(100% - 2.5rem);

  color: var(--clr-text-blue);

  @media (min-width: 40em) {
    flex-direction: row;
    align-items: center;
    width: auto;
    padding: 2rem;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1rem;
  margin-top: 3.75rem;

  @media (min-width: 40em) {
    margin-top: 0;
    margin-left: 7.5rem;
    width: 27rem;
    min-width: 15rem;
  }
`
